import { clone } from '../../utils/object-helpers';

export const itemCardSinglePropertyRearrange = ({
    propertyOrdering = {},
    propertyName,
    newSection,
    position = 0,
    newName = propertyName,
    createIfMissing = false
}) => {
    let propertyRemoved = false;
    if (propertyName) {
        // Remove existing property
        for (const section in propertyOrdering) {
            if (propertyOrdering.hasOwnProperty(section)) {
                propertyOrdering[section] = (propertyOrdering[section] || [])
                    // eslint-disable-next-line no-loop-func
                    .map(propsArray => {
                        const filtered = propsArray.filter(
                            property => property !== propertyName && property !== newName
                        );
                        if (filtered.length < propsArray.length) {
                            propertyRemoved = true;
                        }
                        return filtered;
                    })
                    .filter(propsArray => !!propsArray.length);
            }
        }
    }
    if (newSection) {
        if (!propertyOrdering[newSection]) {
            // Make sure the new section exists
            propertyOrdering[newSection] = [];
        }
        if (
            newName &&
            !propertyOrdering[newSection].find(it => it.includes(newName)) &&
            (createIfMissing || propertyRemoved)
        ) {
            // Insert property in the new section using the new name and in the right position
            propertyOrdering[newSection].splice(position, 0, [newName]);
        }
    }
    return propertyOrdering;
};

export const itemCardPropertyRearrange = (propertyOrdering = {}, mutations = []) => {
    let mutatedPropertyOrdering = clone(propertyOrdering);
    for (const mutation of mutations) {
        mutatedPropertyOrdering = itemCardSinglePropertyRearrange({ ...mutation, propertyOrdering });
    }
    return mutatedPropertyOrdering;
};
